exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".jf-evently[data-v-1a2bb8e6]{-ms-flex-pack:space-evenly;justify-content:space-evenly}.logo[data-v-1a2bb8e6]{min-height:55px}.logo__line[data-v-1a2bb8e6]{padding-left:0;padding-right:0;padding-bottom:8px}.logo__link[data-v-1a2bb8e6]{color:black;text-align:center;font-size:12px;display:-ms-flexbox;display:flex;flex-direction:column;-ms-flex-direction:column}.logo__text[data-v-1a2bb8e6]{margin-top:5px;font-size:12px;font-weight:500;text-align:center}.logo__icon[data-v-1a2bb8e6]{font-size:28px;height:28px}\n", ""]);

// exports
